import { useState } from "react";
import { useTranslation } from "react-i18next";
import Tooltip from "@kea-mod/common/tooltip";

type Props = {
  maxScore: string;
  setMaxScore: (value: string) => void;
};

export const ScoreField = (props: Props) => {
  const { t } = useTranslation();
  const [hasInvalidInput, setHasInvalidInput] = useState(false);

  function onChangeMaxScore(e: any) {
    let val = e.target.value;
    const v = e.target.value;
    const myArray = e.target.value.split(".");

    if (myArray[0].toString().length >= 11) {
      return;
    }
    if (myArray.length !== 1 && myArray[1].toString().length >= 3) {
      return;
    }

    if (e.target.validity.valid) {
      val = val.replace(/^0+/, "");
      if (val === "") {
        val = v;
      }

      if (val.startsWith(".")) {
        val = "0" + val;
      }

      setHasInvalidInput(false);
      props.setMaxScore(val);
    } else if (val === "" || val === "-") {
      val = val.replace(/^0+/, "");
      if (val === "") {
        val = v;
      }

      if (val.startsWith(".")) {
        val = "0" + val;
      }

      setHasInvalidInput(false);
      props.setMaxScore(val);
    } else {
      // Rejected input never changes props.maxScore, so React sees no prop
      // diff and won't overwrite the DOM value on its own — reset it here
      // so the field doesn't visually keep characters that were never saved.
      e.target.value = props.maxScore;
      setHasInvalidInput(true);
    }
  }

  return (
    <div className="field">
      <div className="label">
        {t("MaxScore")}
        <Tooltip
          icon="circle-info"
          class="icon tooltip no-border is-white   has-tooltip-multiline has-tooltip-top"
          content={t("maxscoreTooltip")}
        ></Tooltip>
      </div>
      <div>
        <input
          size={5}
          className="input"
          type="text"
          value={props.maxScore}
          onChange={onChangeMaxScore}
          pattern="^[+\-]?\d*\.?\d*$"
        />
        {hasInvalidInput && <p className="help is-danger">{t("maxScoreInvalidInput")}</p>}
      </div>
    </div>
  );
};
